import Vue from 'vue'
import {createPinia, PiniaVuePlugin} from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import VueCustomElement from 'vue-custom-element'

import {
	Button,
	Field,
	Input,
	Loading,
	Message,
	Modal,
	Notification,
	Numberinput,
	Progress,
	Rate,
	Select,
	Table,
	Tooltip,
} from 'buefy'
import axios from 'axios'
import VueAxios from 'vue-axios'
import './assets/buefy.css'
import App from "@/App.vue";

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
Vue.use(PiniaVuePlugin)
Vue.use(Message)
Vue.use(Tooltip)
Vue.use(Modal)
Vue.use(Progress)
Vue.use(Table)
Vue.use(Input)
Vue.use(Button)
Vue.use(Loading)
Vue.use(Rate)
Vue.use(Notification)
Vue.use(Field)
Vue.use(Numberinput)
Vue.use(Select)
Vue.use(VueAxios, axios)
Vue.use(VueCustomElement)

Vue.component('Foerderrechner_fuer_Heizungstausch', () => import('./components/Foerderrechner_fuer_Heizungstausch.vue'));
Vue.component('Foerderrechner_fuer_Einzelmassnahmen', () => import('./components/Foerderrechner_fuer_Einzelmassnahmen.vue'));
Vue.component('button_rueckruf', () => import('./components/button_rueckruf.vue'));
Vue.component('ReviewBox', () => import('./components/reviews/ReviewBox.vue'));
Vue.component('ReviewsIndex', () => import('./components/reviews/index.vue'));
Vue.component('Heizkostenrechner_fuer_Bestandsgebaeude', () => import('./components/Heizkostenrechner_fuer_Bestandsgebaeude.vue'));
Vue.component('rateComponent', () => import('./components/reviews/components/rate.vue'));
Vue.component('ReviewPlattformBoxes', () => import('./components/reviews/components/plattformBoxes.vue'));
Vue.component('ReviewPartial', () => import('./components/reviews/ReviewPartial.vue'));
Vue.component('ReviewCarousel', () => import('./components/reviews/ReviewCarousel.vue'));
Vue.component('Quiz_VA_oder_BA', () => import('./components/Quiz_VA_oder_BA.vue'));
Vue.component('Heizwert_Brennwert_converter', () => import('./components/Heizwert_Brennwert_converter.vue'));


new Vue({
	el: '#app',
	pinia,
	render: h => h(App),
})

Vue.customElement('iw-bewertungen-grid', () => new Promise((resolve) => {
	require(['./components/reviews/index.vue'], (lazyComponent) => resolve(lazyComponent.default));
}), {props: ['prop']});
Vue.customElement('iw-bewertungen-carousel', () => new Promise((resolve) => {
	require(['./components/reviews/ReviewCarousel.vue'], (lazyComponent) => resolve(lazyComponent.default));
}), {props: ['prop']});
Vue.customElement('iw-foerderrechner-heizungstausch', () => new Promise((resolve) => {
	require(['./components/Foerderrechner_fuer_Heizungstausch.vue'], (lazyComponent) => resolve(lazyComponent.default));
}), {props: ['prop']});
Vue.customElement('iw-foerderrechner-einzelmassnahmen', () => new Promise((resolve) => {
	require(['./components/Foerderrechner_fuer_Einzelmassnahmen.vue'], (lazyComponent) => resolve(lazyComponent.default));
}), {props: ['prop']});
Vue.customElement('iw-heizkostenrechner', () => new Promise((resolve) => {
	require(['./components/Heizkostenrechner_fuer_Bestandsgebaeude.vue'], (lazyComponent) => resolve(lazyComponent.default));
}), {props: ['prop']});
Vue.customElement('iw-rueckruf-component', () => new Promise((resolve) => {
	require(['./components/button_rueckruf.vue'], (lazyComponent) => resolve(lazyComponent.default));
}), {props: ['prop']});
Vue.customElement('iw-bewertungen-infobox', () => new Promise((resolve) => {
	require(['./components/reviews/ReviewPartial.vue'], (lazyComponent) => resolve(lazyComponent.default));
}), {props: ['prop']});
Vue.customElement('iw-ausweis-quiz', () => new Promise((resolve) => {
	require(['./components/Quiz_VA_oder_BA.vue'], (lazyComponent) => resolve(lazyComponent.default));
}), {props: ['prop']});
Vue.customElement('iw-heizwert-brennwert-converter', () => new Promise((resolve) => {
	require(['./components/Heizwert_Brennwert_converter.vue'], (lazyComponent) => resolve(lazyComponent.default));
}), {props: ['prop']});


/**
 * todo lazy loading
 * Vue.customElement('demo-lazy-loading', () => new Promise((resolve) => {
 *   require(['path/to/lazy-loaded-component'], (lazyComponent) => resolve(lazyComponent.default)));
 * }), { props: ['prop'] });
 * https://karol-f.github.io/vue-custom-element/#/demos/lazy-loading
 *
 */
// Object.keys(components).forEach(async name => {
// 	const component = await components[name]();
// 	// component.default.store = pinia;
// 	Vue.customElement(name, component.default)
// })

if (document.getElementById('ReviewBox')) {
	new Vue({
		el: '#ReviewBox',
		pinia,
		render: (h) => {
			return h('ReviewBox')
		},
	})
}